import React from "react";
import { Link } from "react-router-dom";
import { Star, Zap, Gauge, BatteryCharging, ArrowUpRight } from "lucide-react";

const CATEGORY_LABEL = {
  "electric-bicycle": "Electric Bicycle",
  "low-speed-scooter": "Low-Speed Scooter",
  "high-speed-scooter": "High-Speed Scooter",
  "electric-motorcycle": "Electric Motorcycle",
};

export const BikeCard = ({ bike, index = 0 }) => {
  return (
    <Link
      to={`/bikes/${bike.id}`}
      data-testid={`bike-card-${bike.id}`}
      className="card-premium group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
        <img
          src={bike.image}
          alt={`${bike.brand} ${bike.name}`}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-4 left-4 flex gap-2">
          <span className="px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider bg-[#3DDC97] text-[#0A0B10] flex items-center gap-1">
            <Zap size={11} /> Electric
          </span>
        </div>
        <div className="absolute top-4 right-4 flex items-center gap-1 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur text-white text-xs font-medium">
          <Star size={11} className="fill-[#3DDC97] text-[#3DDC97]" />
          <span className="font-mono-num">{bike.rating}</span>
        </div>
      </div>

      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-widest text-gray-500 font-medium truncate">{bike.brand}</p>
            <h3 className="font-display font-bold text-lg mt-0.5 text-ink leading-tight truncate">{bike.name}</h3>
            <p className="text-[10px] uppercase tracking-widest text-[#2D7FF9] font-bold mt-1">
              {CATEGORY_LABEL[bike.category] || bike.category}
            </p>
          </div>
          <ArrowUpRight size={18} className="text-gray-400 group-hover:text-[#2D7FF9] group-hover:rotate-45 transition-all shrink-0" />
        </div>

        <div className="mt-4 grid grid-cols-3 gap-2 text-xs">
          <div className="min-w-0 flex flex-col items-start gap-1 p-2 rounded-lg bg-gray-50">
            <Zap size={12} className="text-[#3DDC97]" />
            <div className="min-w-0 w-full">
              <p className="text-[9px] uppercase tracking-widest text-gray-500">Range</p>
              {bike.range_label ? (
                <p className="font-mono-num font-bold text-ink text-[11px] truncate">{bike.range_label}</p>
              ) : (
                <p className="font-mono-num font-bold text-ink text-[12px] leading-tight whitespace-nowrap">
                  <span className="text-[9px] font-medium text-gray-500 lowercase tracking-wide mr-0.5">upto</span>
                  {bike.range_km}<span className="text-[10px] font-medium text-gray-500 ml-0.5">km</span>
                </p>
              )}
            </div>
          </div>
          <div className="min-w-0 flex flex-col items-start gap-1 p-2 rounded-lg bg-gray-50">
            <Gauge size={12} className="text-[#2D7FF9]" />
            <div className="min-w-0 w-full">
              <p className="text-[9px] uppercase tracking-widest text-gray-500">Top</p>
              <p className="font-mono-num font-bold text-ink text-[11px] truncate">{bike.top_speed_label || `${bike.top_speed} km/h`}</p>
            </div>
          </div>
          <div className="min-w-0 flex flex-col items-start gap-1 p-2 rounded-lg bg-gray-50">
            <BatteryCharging size={12} className="text-[#3DDC97]" />
            <div className="min-w-0 w-full">
              <p className="text-[9px] uppercase tracking-widest text-gray-500">Charge</p>
              <p className="font-mono-num font-bold text-ink text-[11px] truncate">{bike.charging_time || "5 hrs"}</p>
            </div>
          </div>
        </div>

        <div className="mt-5 pt-4 border-t border-gray-100 flex items-center justify-between gap-2">
          <span className="text-xs font-semibold text-gray-600 capitalize">
            {bike.available ? "Available in" : "Unavailable"} <span className="text-ink font-bold">{bike.city}</span>
          </span>
          <span className="text-xs px-3 py-1.5 rounded-full bg-brand-gradient text-white font-semibold">
            Rent Now
          </span>
        </div>
      </div>
    </Link>
  );
};
